<template>
  <v-dialog ref="dialog" v-model="modal" persistent width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field
        :disabled="checkDatePickerDisabled"
        outlined
        v-model="computedDateFormattedMomentjs"
        :rules="dateRules"
        :label="orderDateLabel"
        prepend-inner-icon="event"
        readonly
        v-on="on"
      ></v-text-field>

      <v-alert
        v-if="checkDatePickerDisabled"
        type="warning"
        border="left"
      >Unfortunately no dates are available at this time.</v-alert>
    </template>
    <v-date-picker
      v-model="orderDate"
      no-title
      :allowed-dates="getAllowedDates"
      v-on:change="modal= false"
      :min="nowDate"
    >
      <v-spacer></v-spacer>
      <v-btn text color="blue darken-2" @click="modal = false">Cancel</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import moment from "moment";

export default {
  components: {},

  props: {
    template: null,
    order: null,
     standing : null
  },

  data() {
    return {
      orderDate: null,
      modal: false,
      dateRules: [v => !!v || "Date is required"],
      nowDate: new Date().toISOString().slice(0,10),
    };
  },
  computed: {
    
    orderDateLabel() {
      let label = "Delivery Date";

      if (this.$store.getters.retrieveIsCncCustomer) {
        label = "Collection Date";
      }
       if (this.standing) {
        label = "Start Date"
      }

      return label;
    },

    computedDateFormattedMomentjs() {
      return this.orderDate
        ? moment(this.orderDate).format("dddd, Do MMMM YYYY")
        : "";
    },
    checkDatePickerDisabled() {
      let datesDisabled = true;

      if (this.$store.getters.retrieveAllAvailableDays.length > 0) {
        datesDisabled = false;
      }

      return datesDisabled;
    }
  },

  activated() {
    console.log("-- Activated Date");
    console.log(this.standing)
    console.log(this.template);

    if (this.order && this.template != true ) {
      this.orderDate = this.order.order_date;
      if(this.orderDate < this.nowDate) {
        if(this.standing) {
          this.orderDate = this.$store.getters.retrieveStandingOrderDays[0]
        }else{
          this.orderDate = this.$store.getters.retrieveAllAvailableDays[0]
        }
      }
     } else {
      this.orderDate = null;
    }
    
  },

  methods: {
    getAllowedDates(val) {
      if (this.standing) {
        if (this.$store.getters.retrieveStandingOrderDays.indexOf(val)!== -1){
          return true
        }
        return false
      } else {
        if (this.$store.getters.retrieveAllAvailableDays.indexOf(val) !== -1) {
          return true;
        }
        return false
      }
      // if (this.$store.getters.retrieveAllAvailableDays.indexOf(val) !== -1) {
      //   return true;
      // } else {
      //   return false;
      // }
    }
  },

  watch: {
    orderDate() {
      this.$emit("input", this.orderDate);
    },
    order : function(val) {
      if(val) {
        this.orderDate = val.order_date
        console.log('order watch with val ' + val.order_date)
      }
    }
  }
};
</script>